import React, { Fragment } from 'react';
import loadable from '@loadable/component';
import { compose } from '@/utils/story-composer';
import PointUp from '../icons/point-up';
import PointDown from '../icons/point-down';
import Icon from '@/images/language-switch-icon.svg';

const Listbox = loadable(() => import('@headlessui/react').then(headlessUi => headlessUi.Listbox), {
	ssr: true,
});
const Transition = loadable(() => import('@headlessui/react').then(headlessUi => headlessUi.Transition), { ssr: true });

function Dropdown({ items, selectedItem, setSelected }) {
	return (
		<div className="w-full">
			<Listbox value={selectedItem} onChange={setSelected}>
				{({ open }) => (
					<div className="relative">
						<Listbox.Button
							className={`relative w-full h-10 px-3 text-left bg-white rounded ${
								open ? 'rounded-t-none' : ''
							} border-heather border cursor-default`}
						>
							<div className="flex">
								<Icon />
								<span className="ml-2 block truncate">{selectedItem.value}</span>
								<span className="absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none">
									{open ? <PointUp /> : <PointDown />}
								</span>
							</div>
						</Listbox.Button>
						<Transition
							as={Fragment}
							leave="transition ease-in duration-100"
							leaveFrom="opacity-100"
							leaveTo="opacity-0"
						>
							<Listbox.Options className="absolute bottom-0 mb-10 bg-white border border-b-0 border-heather w-full rounded-t">
								{items.map((item, valueIdx) => (
									<Listbox.Option
										// eslint-disable-next-line react/no-array-index-key
										key={valueIdx}
										value={item}
										className={({ active }) =>
											`cursor-default select-none relative h-10 items-center flex px-4 ${
												active ? 'bg-solitude' : 'bg-white'
											}`
										}
									>
										{({ selected }) => (
											<>
												<span className={`block truncate ${selected ? 'font-semibold' : 'font-normal'}`}>
													{item.value}
												</span>
												{selected ? <span className="absolute inset-y-0 left-0 flex items-center pl-3" /> : null}
											</>
										)}
									</Listbox.Option>
								))}
							</Listbox.Options>
						</Transition>
					</div>
				)}
			</Listbox>
		</div>
	);
}
compose('dropdown', Dropdown);

export default Dropdown;
